import { render, staticRenderFns } from "./SelectLegislation.vue?vue&type=template&id=0319b943&scoped=true&"
import script from "./SelectLegislation.vue?vue&type=script&lang=js&"
export * from "./SelectLegislation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319b943",
  null
  
)

export default component.exports